import type { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import type { NuasApp } from '@eliboo/api-models';

import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { MICRO_ROUTE_HOST } from '@eliboo/micro-ng/router';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { useGetBusinessLicense } from '../api/biz/use-license-upload.api';

export const bizLicenseResolver: ResolveFn<NuasApp.UserBusinessLicenseInfoDTO> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  console.log('bizLicenseResolver', route, state.url);

  const getBusinessLicense = useGetBusinessLicense().api;
  const host = inject(MICRO_ROUTE_HOST);
  const router = inject(Router);
  return getBusinessLicense().pipe(
    map((res) => {
      const data = res.data?.[0];
      return data;
    }),
    switchMap((res) => {
      if (res && res?.auditStatusEnum !== 'REJECTED' && !state.url.includes('upload-result')) {
        return of(new RedirectCommand(router.parseUrl(`${host}/biz/upload-result`)));
      }
      if ((res && res?.auditStatusEnum === 'REJECTED' || !res) && state.url.includes('upload-result')) {
        return of(new RedirectCommand(router.parseUrl(`${host}/biz/license-upload`)));
      }
      return of(res);
    }),
    catchError((err) => {
      console.log("bizLicenseResolver error", err);
      if (err?.error?.code === 'B0001' && state.url.includes('upload-result')) {
        return of(new RedirectCommand(router.parseUrl(`${host}/biz/license-upload`)));
      }
      return of({})
    }),
  );
};
